import { useEffect, useState } from "react";
import { GET_WEB_NOTIFICATION_COUNT_ROUTE } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";

export interface IAlertCount {
    count: number;
}

export const useGetAlertCount = () => {
    const [count, setCount] = useState(0);
    const [, { get }] = useFetch();

    const getAlertCount = () => {
        get<IAlertCount>(GET_WEB_NOTIFICATION_COUNT_ROUTE).then((result) => {
            setCount(result ? result.count : 0);
        });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getAlertCount, []);

    return { count };
};
